import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import FormLoading from './components/FormLoading';

// Every page is code-split: a visitor downloads only the route they landed on
// instead of all 26 retainer/form pages in one bundle. Matters most for the
// physician-facing RFC forms, which race the DocuSeal iframe for bandwidth.
const SSDIRetainer = lazy(() => import('./pages/ssdi-retainer'));
const DemandLaneRetainer = lazy(() => import('./pages/demand-lane-ssdi-retainer'));
const FirstPartyPropertyRetainer = lazy(() => import('./pages/first-party-property-retainer'));
const FirstPartyPropertyRetainer33 = lazy(() => import('./pages/first-party-property-retainer-33'));
const ManualFppRetainer = lazy(() => import('./pages/manual-fpp-retainer'));
const Helene = lazy(() => import('./pages/helene'));
const FppIntakeTeam = lazy(() => import('./pages/fpp-intake-team'));
const GoogleAdsRetainer = lazy(() => import('./pages/google-ads-retainer'));
const HurricaneRetainer25 = lazy(() => import('./pages/hurricane-retainer-25'));
const HurricaneRetainer20 = lazy(() => import('./pages/hurricane-retainer-20'));
const HurricaneRetainer = lazy(() => import('./pages/hurricane-retainer'));
const EmploymentLaw = lazy(() => import('./pages/employment-law'));
const PersonalInjury = lazy(() => import('./pages/personal-injury'));
const FirstPartyPropertyRetainer25 = lazy(() => import('./pages/first-party-property-retainer-25'));
const FirstPartyPropertyRetainer20 = lazy(() => import('./pages/first-party-property-retainer-20'));
const WarrantyRetainer = lazy(() => import('./pages/warranty-retainer'));
const TexasRetainer = lazy(() => import('./pages/texas-fpp'));
const ThirdPartyRetainer = lazy(() => import('./pages/third-party-retainer-property-damage-claim'));
const AmericanHomeShieldRetainer = lazy(() => import('./pages/american-home-shield-retainer'));
const PrudentialRetainer = lazy(() => import('./pages/prudential-retainer'));
const EverbankRetainer = lazy(() => import('./pages/everbank-retainer'));
const AmericanIntegrityRetainer = lazy(() => import('./pages/american-integrity-retainer'));
const FamilyLawRetainer = lazy(() => import('./pages/family-law-retainer'));
const VuoriConsent = lazy(() => import('./pages/vuori-consent'));
const MentalRfc = lazy(() => import('./pages/mental-rfc'));
const PhysicalRfc = lazy(() => import('./pages/physical-rfc'));
const RepDoc1696 = lazy(() => import('./pages/rep-doc-1696'));
const ThankYou = lazy(() => import('./pages/thank-you'));

const BlankHome = () => {
  return null; // Renders nothing
};

// Repaints the same skeleton index.html showed, so the hand-off from the
// static shell to the route chunk is seamless rather than a navy flash.
const RouteFallback = () => <FormLoading />;

function App() {
  return (
    <Router>
      <Suspense fallback={<RouteFallback />}>
        <Routes>
          <Route path="/" element={<BlankHome />} />
          <Route path="/ssdi-retainer" element={<SSDIRetainer />} />
          <Route path="/first-party-property-retainer" element={<FirstPartyPropertyRetainer />} />
          <Route path="/first-party-property-retainer-20" element={<FirstPartyPropertyRetainer20/>} />
          <Route path="/first-party-property-retainer-25" element={<FirstPartyPropertyRetainer25/>} />
          <Route path="/first-party-property-retainer-33" element={<FirstPartyPropertyRetainer33 />} />
          <Route path="/manual-fpp-retainer" element={<ManualFppRetainer />} />
          <Route path="/hurricane-helene-retainer" element={<Helene />} />
          <Route path="/fpp-intake-team" element={<FppIntakeTeam />} />
          <Route path="/demand-lane-ssdi-retainer" element={<DemandLaneRetainer />} />
          <Route path="/google-ads-retainer" element={<GoogleAdsRetainer />} />
          <Route path="/hurricane-retainer" element={<HurricaneRetainer />} />
          <Route path="/hurricane-retainer-25" element={<HurricaneRetainer25 />} />
          <Route path="/hurricane-retainer-20" element={<HurricaneRetainer20 />} />
          <Route path="/employment-law" element={<EmploymentLaw />} />
          <Route path="/personal-injury-retainer" element={<PersonalInjury/>} />
          <Route path="/warranty-retainer" element={<WarrantyRetainer/>} />
          <Route path="/texas-fpp-retainer" element={<TexasRetainer/>} />
          <Route path="/third-party-retainer" element={<ThirdPartyRetainer/>} />
          <Route path="/american-home-shield-retainer" element={<AmericanHomeShieldRetainer />} />
          <Route path="/prudential-retainer" element={<PrudentialRetainer />} />
          <Route path="/everbank-retainer" element={<EverbankRetainer />} />
          <Route path="/american-integrity-retainer" element={<AmericanIntegrityRetainer />} />
          <Route path="/family-law-retainer" element={<FamilyLawRetainer />} />
          <Route path="/vuori-consent" element={<VuoriConsent />} />
          <Route path="/mental-rfc" element={<MentalRfc />} />
          <Route path="/physical-rfc" element={<PhysicalRfc />} />
          <Route path="/rep_doc_1696" element={<RepDoc1696 />} />
          <Route path="/thank-you" element={<ThankYou />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
